module.exports = __webpack_public_path__ + "static/media/football-3.fa230053.jpg";